import { useState } from 'react';
import dayjs from 'dayjs';
import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { Grid } from '@mui/material';
import { Link } from '@mui/material';
import { DELETE, EDIT } from './AppConstants';
import { getUserName, PhaseBadges } from './UtilFunctions';

export default function EntityLinks({
  commonProps,
  entity,
  openEntity,
  editEntity,
  removeEntity,
  readOnly,
  userInfoMap,
  showHideEnabled,
  handleShowHide,
  doNotShowPhaseTags
}) {
  let formatString = 'DD-MMM-YYYY [at] h:mma ZZ';

  const DropDownItems = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const close = () => setAnchorEl(null);
    return (
      <>
        <IconButton
          aria-label="More Actions"
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <fuel-icon name={'more_vertical'} />
        </IconButton>
        <Menu anchorEl={anchorEl} onClose={close} open={Boolean(anchorEl)}>
          <MenuItem
            onClick={(e) => {
              editEntity(e, entity);
              close();
            }}
          >
            <fuel-icon name={'edit'} />
            {EDIT}
          </MenuItem>
          {showHideEnabled && (
            <MenuItem
              onClick={(e) => {
                handleShowHide(e, entity);
                close();
              }}
            >
              {entity?.visibleOnSummary ? (
                <fuel-icon name={'visibility_off'} />
              ) : (
                <fuel-icon name={'visibility'} />
              )}
              {entity?.visibleOnSummary
                ? 'Hide on Strategy Info'
                : 'Show on Strategy Info'}
            </MenuItem>
          )}
          <MenuItem
            onClick={(e) => {
              removeEntity(e, entity);
              close();
            }}
          >
            <fuel-icon name={'delete'} />
            {DELETE}
          </MenuItem>
        </Menu>
      </>
    );
  };

  const LinkedFileName = () => {
    const entityContent = entity.url ?? entity.comment;
    const showHiddenLink = showHideEnabled && !entity?.visibleOnSummary;

    return (
      <Grid container alignItems="center">
        <Grid>
          {entityContent ? (
            <Typography>
              {`${showHiddenLink ? '(Hidden) ' : ''}`}
              {entityContent}
            </Typography>
          ) : (
            <>
              {entity?.templateId || entity?.attachment ? (
                <Link
                  href="#"
                  size={'medium'}
                  onClick={(e) => {
                    e.preventDefault();
                    openEntity(e, entity, commonProps);
                  }}
                >
                  {`${showHiddenLink ? '(Hidden) ' : ''}`}
                  {entity?.fileName ?? entity?.attachment}
                </Link>
              ) : (
                (entity?.fileName ?? entity?.attachment)
              )}
            </>
          )}
        </Grid>
      </Grid>
    );
  };

  const Description = () => {
    const desc = entity.description || entity.comment;

    return (
      <>
        {desc && (
          <Typography component="div" variant="bodyMedium">
            {desc}
          </Typography>
        )}
      </>
    );
  };

  const FileDetails = () => {
    return (
      <>
        {entity?.updatedById && (
          <Typography component="div" variant="bodyMedium">
            {getUserName(entity.updatedById, userInfoMap) +
              ' on ' +
              dayjs(new Date(entity.updatedOn)).format(formatString)}
          </Typography>
        )}
      </>
    );
  };

  return (
    <>
      <Grid
        display={'flex'}
        justifyContent={'start'}
        paddingTop={2}
        paddingBottom={2}
      >
        {!readOnly && <DropDownItems />}
        <Grid>
          <LinkedFileName />
          <FileDetails />
          {!doNotShowPhaseTags && <PhaseBadges file={entity} />}
          {!entity.comment && <Description />}
        </Grid>
      </Grid>
    </>
  );
}
